const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

const fmtQty = (value) => {
  const number = Number(value || 0);
  if (!Number.isFinite(number)) return "";
  if (Math.abs(number - Math.trunc(number)) < 0.000001) return `${Math.trunc(number)}`;
  return number.toFixed(3).replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");
};

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const bodyRows = rows
    .map(
      (row, index) => `
      <tr>
        <td class="cell center">${index + 1}</td>
        <td class="cell">${escapeHtml(row.itemName || "")}</td>
        <td class="cell center">${escapeHtml(row.unit || "")}</td>
        <td class="cell right">${fmtQty(row.quantity)}</td>
        <td class="cell right">${fmtMoney(row.unitPrice)}</td>
        <td class="cell right">${fmtMoney(row.amount)}</td>
        <td class="cell">${escapeHtml(row.note || "")}</td>
      </tr>`
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Bảng kê vàng tiền tệ</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:12px; font-size:20px; font-weight:700; text-transform:uppercase; }
        .note { font-style: italic; margin-top: 6px; }
        .meta-right { text-align:right; margin-top:6px; line-height: 1.6; }
        table { width:100%; border-collapse: collapse; margin-top: 12px; }
        .cell { border: 1px solid #000; padding: 4px 6px; font-size: 14px; }
        .center { text-align: center; }
        .right { text-align: right; }
        .bold { font-weight: 700; }
        .signatures { margin-top:24px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width:23%; }
        .sign-spacer { height: 16px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số: 06 - TT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">BẢNG KÊ VÀNG TIỀN TỆ</div>

      <div class="note">
        (Đính kèm phiếu ${escapeHtml(headerInfo.attachedVoucher || "")}<br/>
        Ngày ${escapeHtml(headerInfo.attachedVoucherDate || ".../.../....")})
      </div>

      <div class="meta-right">
        <div>Quyển số: ${escapeHtml(headerInfo.bookNumber || "")}</div>
        <div>Số: ${escapeHtml(headerInfo.documentNumber || "")}</div>
      </div>

      <table>
        <thead>
          <tr>
            <th class="cell center">STT</th>
            <th class="cell center">Tên, loại, quy cách phẩm chất</th>
            <th class="cell center">Đơn vị tính</th>
            <th class="cell center">Số lượng</th>
            <th class="cell center">Đơn giá</th>
            <th class="cell center">Thành tiền</th>
            <th class="cell center">Ghi chú</th>
          </tr>
          <tr>
            <th class="cell center">A</th>
            <th class="cell center">B</th>
            <th class="cell center">C</th>
            <th class="cell center">1</th>
            <th class="cell center">2</th>
            <th class="cell center">3</th>
            <th class="cell center">D</th>
          </tr>
        </thead>
        <tbody>
          ${bodyRows}
          <tr>
            <td class="cell center"></td>
            <td class="cell center bold">Cộng</td>
            <td class="cell"></td>
            <td class="cell right bold">${fmtQty(totals?.quantity || 0)}</td>
            <td class="cell"></td>
            <td class="cell right bold">${fmtMoney(totals?.amount || 0)}</td>
            <td class="cell"></td>
          </tr>
        </tbody>
      </table>

      <div class="signatures">
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Kế toán trưởng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Người nộp (nhận)</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Thủ quỹ</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div><i>Ngày... tháng... năm...</i></div>
          <div><b>Người kiểm nghiệm</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
